import http from "../../core/services/http.service";

const RelationsService = {
  getRelations(params = null) {
    return http.get(`/api/v1/relations/`, {params});
  },
  updateRelation(id, data, expand = '') {
    return http.put(`/api/v1/relations/${id}/?expand=${expand}`, data);
  },
  createRelation(data) {
    return http.post('/api/v1/relations/', data);
  },
  removeRelation(uuid) {
    return http.delete(`/api/v1/relations/${uuid}/`)
  },
};

export default RelationsService;
